import { ICON_SIZE } from '@components/v2/constants';
import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import type { AlertSeverity } from './alert.types';

export const FLOATING_MAX_WIDTH = 420;
const FLOATING_MESSAGE_MAX_WIDTH = 240;
const CLOSE_SLOT_SIZE = 28;

export const useAlertStyles = makeStyles<{ severity: AlertSeverity; isFloating: boolean }>({
  name: 'Alert',
})((theme, { severity, isFloating }) => {
  const border = `inset 0 0 0 0.5px ${alpha(theme.palette[severity].main, 0.2)}`;

  return {
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%',
      maxWidth: isFloating ? FLOATING_MAX_WIDTH : undefined,
      boxSizing: 'border-box',
      padding: theme.spacing(0.75),
      borderRadius: theme.shape.borderRadiusXl,
      backgroundColor: theme.palette[severity].light,
      boxShadow: isFloating ? `${border}, ${theme.shadows[8]}` : border,
    },
    content: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      flex: 1,
      minWidth: 0,
      padding: theme.spacing(0.75),
    },
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: ICON_SIZE.md,
      height: ICON_SIZE.md,
      color: theme.palette[severity].dark,
    },
    texts: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      minWidth: 0,
      wordBreak: 'break-word',
    },
    title: {
      lineHeight: 1.2,
    },
    message: {
      maxWidth: isFloating ? FLOATING_MESSAGE_MAX_WIDTH : undefined,
    },
    closeSlot: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: CLOSE_SLOT_SIZE,
      height: CLOSE_SLOT_SIZE,
    },
    closeButton: {
      '&:hover': { backgroundColor: 'transparent' },
    },
  };
});
